import { gql } from '@apollo/client';

const GET_ENVIRONMENT_FUND = gql`
  query GetEnvironmentFund($requestingPlatformCode: String) {
    getEnvironmentFund(requestingPlatformCode: $requestingPlatformCode) {
      id
      email
      address
      masterEntity {
        id
        name
        displayNationalIdentifier
      }
    }
  }
`;

export default GET_ENVIRONMENT_FUND;
